import React, { FC, useEffect, useRef } from "react";
import { useState } from "react";
import { Accordion, Col, Row } from "react-bootstrap";
import {
  addCategory,
  getCategoryImageById,
} from "../../serviceBroker/categoryApiServiceBroker";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  ActionTypeEnum,
  CategoryResponseModel,
  HasFormIdModel,
  ItemImageModel,
  LookupItemModel,
  LookupTypeEnum,
  PageEnum,
  RequestActionModel,
  RowStateEnum,
  ValidationErrorModel,
  LoadingObjectsEnum,
  SystemModulesEnum,
} from "../../models";
import {
  LoadingBox,
  TextBox,
  ButtonBox,
  PrivilegesChecker,
  ItemImageManager,
} from "..";
import {
  getLabelName,
  getPageNameByPageId,
  isSystemConfigurationModuleEnabled,
  validateNoSpaces,
  validateRequired,
  yubCombineValidationsManager,
} from "../../utils";
import { getLookupByType } from "../../serviceBroker/lookupApiServiceBroker";
import { useLoading, useSystemConfigurations } from "../../hooks";

interface AddCategoryProps extends HasFormIdModel {
  request: CategoryResponseModel | null;
  onActionEvent: (o: RequestActionModel) => void;
}

export const AddCategory: FC<AddCategoryProps> = ({
  request,
  onActionEvent,
  formId,
}) => {
  //#region variables
  const initialValues: CategoryResponseModel = {
    Name: "",
    Name_En: "",
    CreatedBy: 0,
    IsDefault: false,
    IsParent: true,
    Parent_ID: null,
    AllParent: null,
    Code: "",
    CategorySetting: null,
    HasImage: false,
    CreationDate: "",
    Default_Discount_Percentage: 0,
    DisplySequence: 0,
    Errors: [],
    ID: 0,
    IsIgnoreServiceMoneyAdd: false,
    ModificationDate: null,
    ShowInPOS: true,
    VerifyOnUpdate: false,
    ModifiedBy: 0,
    Notes: "",
    rowState: Number(RowStateEnum.Add),
    CategpryImage: null,
  };
  const { loadingData, hideLoader, showLoader } = useLoading({
    [LoadingObjectsEnum.FORM]: false,
    [LoadingObjectsEnum.MODAL]: false,
    [LoadingObjectsEnum.LIST]: false,
  });
  //#endregion
  //#region state
  const selectCategoryRef = useRef<any>(null);
  const [categoryList, setCategoryList] = useState<LookupItemModel[]>([]);
  const validationSchema = Yup.object({
    //Name: Yup.string().required(getLabelName("required")),
    Name: yubCombineValidationsManager([
      validateRequired(),
      validateNoSpaces(),
    ]),
    Name_En: yubCombineValidationsManager([validateNoSpaces()]),
  });
  //#endregion
  //#region functions
  const getImageDataIfExist = async (category: CategoryResponseModel) => {
    if (!category.HasImage) return null;
    showLoader(LoadingObjectsEnum.FORM);
    const ImageData = await getCategoryImageById(category.ID);
    hideLoader(LoadingObjectsEnum.FORM);
    return ImageData.Result as ItemImageModel;
  };
  //#endregion
  const systemConfig = useSystemConfigurations(() => {});
  //#region useEffect
  useEffect(() => {
    if (selectCategoryRef.current) selectCategoryRef?.current?.clearValue();
    const fillData = async () => {
      if (request) {
        const imageData = await getImageDataIfExist(request);
        const categoryImage = imageData
          ? { ...imageData, File64Bit: imageData.File64Bit }
          : null;
        await formik.setValues({
          ...request,
          rowState: request ? RowStateEnum.Update : RowStateEnum.Add,
          CategorySetting: request.CategorySetting
            ? {
                ...request.CategorySetting,
                RowState: RowStateEnum.Update,
                rowState: RowStateEnum.Update,
              }
            : null,
          CategpryImage: categoryImage,
        });
      } else {
        await formik.setValues(initialValues);
      }
      const catList = await getLookupByType(LookupTypeEnum.CategoryType, true);
      setCategoryList(catList);
    };
    fillData().then(() => {});
  }, [request]);
  //#endregion
  //#region formik
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    validateOnBlur: false,
    validateOnChange: false,
    // enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      await handleSubmit(values);
      resetForm();
    },
  });
  //#endregion
  //#region functions
  const handleSubmit = async (request: CategoryResponseModel) => {
    try {
      showLoader(LoadingObjectsEnum.FORM);
      //@ts-ignore
      const res: ResponseBase<StoreResponse> = await addCategory(request);
      if (res != null && res.Errors != null && res.Errors.length !== 0) {
        onActionEvent({
          action: ActionTypeEnum.Failed,
          request: res.Errors,
        });
      } else {
        onActionEvent({ action: ActionTypeEnum.AddSuccess });
      }
    } catch (err: any) {
      const errors: ValidationErrorModel[] = [
        { MessageAr: err, MessageEn: err },
      ];
      onActionEvent({
        action: ActionTypeEnum.Failed,
        request: errors,
      });
    } finally {
      hideLoader(LoadingObjectsEnum.FORM);
    }
  };
  //#endregion
  //#region html
  return (
    <LoadingBox isLoading={loadingData.FORM}>
      <form className="forms-sample" onSubmit={formik.handleSubmit}>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              {getPageNameByPageId(PageEnum.Categories)}
            </Accordion.Header>
            <Accordion.Body>
              <Row>
                {/* <SelectBox
                  labelName={getLabelName("Category")}
                  source={categoryList}
                  isSingleSelect={true}
                  onStatusChange={async (e: any) => {
                    const value = getLookUpItemNumericValue(e);
                    formik.values.Parent_ID = value;
                    await formik.setFieldValue("Parent_ID", value);
                  }}
                  selectedValues={[
                    formik.values.Parent_ID !== null &&
                    formik.values.Parent_ID !== 0
                      ? formik.values.Parent_ID.toString()
                      : formik.values?.CategorySetting?.Category_ID.toString() ||
                        "",
                  ]}
                  multiselectRef={selectCategoryRef}
                /> */}
                <Col md={8}>
                  <Row>
                    <Col md={6} className="mb-3">
                      <TextBox
                        labelName={getLabelName("Arabic Name")}
                        inputName={"Name"}
                        errorText={formik.errors.Name}
                        inputValue={formik.values.Name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <TextBox
                        labelName={getLabelName("Name English")}
                        inputName={"Name_En"}
                        errorText={formik.errors.Name_En}
                        inputValue={formik.values.Name_En}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <TextBox
                        labelName={getLabelName("Code")}
                        inputName={"Code"}
                        errorText={formik.errors.Code}
                        inputValue={formik.values.Code}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <TextBox
                        labelName={getLabelName("Discount Default Ration")}
                        inputName={"Default_Discount_Percentage"}
                        errorText={formik.errors.Default_Discount_Percentage}
                        inputValue={formik.values.Default_Discount_Percentage}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        type="number"
                      />
                    </Col>

                    <Col md={6} className="mb-3">
                      <TextBox
                        labelName={getLabelName("Disply Sequence")}
                        inputName={"DisplySequence"}
                        errorText={formik.errors.DisplySequence}
                        inputValue={formik.values.DisplySequence}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        type="number"
                      />
                    </Col>
                  </Row>
                </Col>
                {isSystemConfigurationModuleEnabled(
                  systemConfig.userConfiguration?.systemModulesConfigurations,
                  (p) => p.ID === SystemModulesEnum.Shared_POS_and_Restaurant
                ) && (
                  <Col md="4">
                    <ItemImageManager
                      isImageLoading={false}
                      image={formik.values.CategpryImage}
                      height={"200px"}
                      width={"100%"}
                      deleteImage={() => {
                        if (!request?.ID)
                          return formik.setFieldValue("CategpryImage", null);
                        formik.setFieldValue("CategpryImage", {
                          ...formik.values.CategpryImage,
                          rowState: RowStateEnum.Delete,
                        });
                        formik.setFieldValue("HasImage", false);
                      }}
                      setFileBase64={(base64: string | null) => {
                        if (base64 === null)
                          return formik.setFieldValue("CategpryImage", null);
                        formik.setFieldValue("CategpryImage", {
                          File64Bit: base64,
                          ID: request?.CategpryImage?.ID
                            ? request?.CategpryImage?.ID
                            : 0,
                          ImageDescription: `${formik.values.Name} item`,
                          ImageName: `${formik.values.Name} item`,
                          Name: formik.values.Name,
                          rowState: request?.ID
                            ? RowStateEnum.Update
                            : RowStateEnum.Add,
                        });
                      }}
                    />
                  </Col>
                )}
              </Row>
              <div className="my-4">
                <TextBox
                  labelName={getLabelName("Notes")}
                  inputName={"Notes"}
                  errorText={formik.errors.Notes}
                  inputValue={formik.values.Notes}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="textarea"
                />
              </div>
              <ul className="list-group row row-cols-1 flex-row row-cols-xxl-3 row-cols-xl-3 row-cols-lg-3 row-cols-md-3 row-cols-sm-1 g-sm-2 g-md-4 align-items-start list-group-wrapper">
                <li className="px-2  position-relative text-decoration-none d-block  text-dark bg-white ">
                  <div className="border border-secondary p-2 px-3">
                    <TextBox
                      labelName={getLabelName("ShowInPOS")}
                      inputName={"ShowInPOS"}
                      errorText={formik.errors.ShowInPOS}
                      inputValue={formik.values.ShowInPOS}
                      controlSize="d-flex justify-content-between"
                      inputContainerClassName="flex-grow-0"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="checkbox"
                    />
                  </div>
                </li>
                <li className="px-2  position-relative text-decoration-none d-block  text-dark bg-white ">
                  <div className="border border-secondary p-2 px-3">
                    <TextBox
                      labelName={getLabelName("Is Default")}
                      inputName={"IsDefault"}
                      errorText={formik.errors.IsDefault}
                      controlSize="d-flex justify-content-between"
                      inputContainerClassName="flex-grow-0"
                      inputValue={formik.values.IsDefault}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="checkbox"
                    />
                  </div>
                </li>
                <li className="px-2  position-relative text-decoration-none d-block  text-dark bg-white ">
                  <div className="border border-secondary p-2 px-3">
                    <TextBox
                      labelName={getLabelName("Is Parent")}
                      inputName={"IsParent"}
                      controlSize="d-flex justify-content-between"
                      errorText={formik.errors.IsParent}
                      inputValue={formik.values.IsParent}
                      onChange={formik.handleChange}
                      inputContainerClassName="flex-grow-0"
                      onBlur={formik.handleBlur}
                      type="checkbox"
                    />
                  </div>
                </li>
                {isSystemConfigurationModuleEnabled(
                  systemConfig.userConfiguration?.systemModulesConfigurations,
                  (p) => p.ID === SystemModulesEnum.Shared_POS_and_Restaurant
                ) && (
                  <li className="px-2  position-relative text-decoration-none d-block  text-dark bg-white ">
                    <div className="border border-secondary p-2 px-3">
                      <TextBox
                        labelName={getLabelName("Is Ignore Service")}
                        inputName={"IsIgnoreServiceMoneyAdd"}
                        controlSize="d-flex justify-content-between"
                        inputContainerClassName="flex-grow-0"
                        errorText={formik.errors.IsIgnoreServiceMoneyAdd}
                        inputValue={formik.values.IsIgnoreServiceMoneyAdd}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        type="checkbox"
                      />
                    </div>
                  </li>
                )}
              </ul>

              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-3">
                <PrivilegesChecker
                  formId={formId}
                  action={request?.ID ? "EnableUpdate" : "EnableSave"}
                >
                  <ButtonBox
                    iconType="content-save"
                    type="submit"
                    className="btn-primary btn-sm mx-3"
                  >
                    {getLabelName(request?.ID ? "Update" : "Save")}
                  </ButtonBox>
                </PrivilegesChecker>
                <ButtonBox
                  iconType="receipt"
                  variant="danger"
                  type="button"
                  className="btn-sm"
                  onClick={(e) => {
                    formik.handleReset(e);
                    onActionEvent({ action: ActionTypeEnum.Clear });
                  }}
                >
                  {getLabelName("New")}
                </ButtonBox>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        {/* <Accordion>
          <Accordion.Item eventKey="3">
            <Accordion.Header>
              {getLabelName("image category")}
            </Accordion.Header>
            <Accordion.Body
              className="overflow-visible position-relative"
              style={{ minHeight: 200 }}
            >
              <ItemImageManager
                isImageLoading={false}
                image={formik.values.CategpryImage}
                deleteImage={() => {
                  if (!request?.ID)
                    return formik.setFieldValue("CategpryImage", null);
                  formik.setFieldValue("CategpryImage", {
                    ...formik.values.CategpryImage,
                    rowState: RowStateEnum.Delete,
                  });
                  formik.setFieldValue("HasImage", false);
                }}
                setFileBase64={(base64: string | null) => {
                  if (base64 === null)
                    return formik.setFieldValue("CategpryImage", null);
                  formik.setFieldValue("CategpryImage", {
                    File64Bit: base64,
                    ID: request?.CategpryImage?.ID
                      ? request?.CategpryImage?.ID
                      : 0,
                    ImageDescription: `${formik.values.Name} item`,
                    ImageName: `${formik.values.Name} item`,
                    Name: formik.values.Name,
                    rowState: request?.ID
                      ? RowStateEnum.Update
                      : RowStateEnum.Add,
                  });
                }}
              />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion> */}
      </form>
    </LoadingBox>
  );
  //#endregion
};
